import React, { useMemo } from 'react';
import { DragCard } from 'components/DragContainer/DragableCard';
import { useDragNDrop } from 'components/DragContainer/hook/useDragNDrop';
import { IQuestionItem, isSelectType } from 'pages/formsCreate/types';
import { QuestionTypeIcon } from './QuestionTypeIcon';
import { ManageQuestion } from './ManageQuestion';
import { Grid, IconButton, Typography } from '@material-ui/core';
import { Delete } from '@material-ui/icons';
import { useStyles } from './styles';
import { QuestionWarning } from './QuestionWarning';

type Props = ReturnType<typeof useDragNDrop<IQuestionItem>> & {
  item: IQuestionItem;
  pos: number;
  onDeleteQuestion: (id: number) => void;
};

export const QuestionDragCard = ({
  handleDrop,
  handleLeave,
  handleOver,
  handleStart,
  item,
  pos,
  onDeleteQuestion
}: Props) => {
  const styles = useStyles();
  const handleDeleteQuestion = () => onDeleteQuestion(item.id);

  const isSelectQuestion = useMemo(() => {
    return isSelectType(item.type);
  }, [item.type]);

  const containsOptions = useMemo(() => {
    return item.options.length > 0;
  }, [item]);

  const showError = useMemo(() => {
    return isSelectQuestion && !containsOptions;
  }, [isSelectQuestion, containsOptions, item]);

  const showWarning = useMemo(() => {
    return isSelectQuestion && item.options.length === 1;
  }, [isSelectQuestion, item]);

  return (
    <DragCard
      item={item}
      pos={pos}
      onDragLeave={handleLeave}
      onDragOver={handleOver}
      onDragStart={handleStart}
      onDragDrop={handleDrop}
      isError={showError}
      isWarn={showWarning}
    >
      <Grid item className={styles.dataContainer} container>
        <QuestionTypeIcon type={item.type} />
        <Typography>
          {item.title}
          {isSelectType(item.type) && <> &nbsp; ({item.options.length}) opções</>}
        </Typography>
        <QuestionWarning isError={showError} isWarn={showWarning} item={item} />
      </Grid>
      <Grid item className={styles.iconsContainer} data-warn={showWarning} data-error={showError}>
        <ManageQuestion item={item} />
        <Grid item>
          <IconButton size="small" onClick={handleDeleteQuestion}>
            <Delete fontSize="small" />
          </IconButton>
        </Grid>
      </Grid>
    </DragCard>
  );
};
